export default __webpack_public_path__ + "static/359-b7bb0536864ff4068253290cd6e98b48.gif";